import { Box } from '@mui/material';
import AdminChatWidget from '@src/App/Components/_UnderConstruction/AdminDashboard/AdminChatWidget';
import AdminSuggestionsWidget from '@src/App/Components/_UnderConstruction/AdminDashboard/AdminSuggestionsWidget';
import AdminSystemStatusWidget from '@src/App/Components/_UnderConstruction/AdminDashboard/AdminSystemStatusWidget';
import AdminUserOverviewWidget from '@src/App/Components/_UnderConstruction/AdminDashboard/AdminUserOverviewWidget';
import QuickActionWidget from '@src/App/Components/_UnderConstruction/AdminDashboard/QuickActionWidget';
import React from 'react';

export default function AdminDashboardSection() {
    return (
        <>
            <Box sx={{ mb: 3 }}>
                <AdminChatWidget />
            </Box>
            <Box sx={{ mb: 3 }}>
                <QuickActionWidget />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 3 }}>
                <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                    <AdminSystemStatusWidget />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                    <AdminUserOverviewWidget />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 3 }}>
                <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                    <AdminSuggestionsWidget />
                </Box>
            </Box>
            {/* Widgets ausgeblendet - Daten noch nicht bereitgestellt */}
            {/* <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 3 }}>
        <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
          <AdminUserActivityWidget />
        </Box>
        <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
          <AdminRecentActivitiesWidget />
        </Box>
      </Box> */}
        </>
    );
}
